export function normalizeBedTypes(payload) {
  const list =
    payload?.bedtype_list ||
    payload?.bed_type_list ||
    payload?.bed_types ||
    payload?.bedtype ||
    payload?.items ||
    payload?.results ||
    payload?.data ||
    (Array.isArray(payload) ? payload : []);

  if (!Array.isArray(list)) return [];

  return list.map((item, index) => {
    const rawBedTypeCode =
      item?.bed_type_code ||
      item?.bedtype_code ||
      item?.bedTypeCode ||
      item?.bedType_code ||
      (item?.bed_type_name ? item?.bed_type : "") ||
      item?.code ||
      item?.value ||
      item?.id ||
      "";

    const bedTypeName =
      item?.bed_type_name ||
      item?.bedtype_name ||
      item?.bed_type ||
      item?.bedtype ||
      item?.type_name ||
      item?.name ||
      item?.label ||
      item?.display_name ||
      `Bed Type ${index + 1}`;

    const bedTypeCode = String(rawBedTypeCode || bedTypeName).trim();

    const totalBedCount = Number(
      item?.total_bed_count ??
      item?.total_count ??
      item?.totalBeds ??
      item?.total_beds ??
      0
    );
    const availableBedCount = Number(
      item?.available_bed_count ??
      item?.available_beds ??
      item?.available_count ??
      item?.availableBeds ??
      0
    );

    return {
      bedTypeCode,
      bedTypeName,
      totalBedCount: Number.isFinite(totalBedCount) ? totalBedCount : 0,
      availableBedCount: Number.isFinite(availableBedCount) ? availableBedCount : 0,
      originalBedTypeCode: String(rawBedTypeCode || "").trim(),
    };
  });
}

export function normalizeBeds(payload) {
  const list =
    payload?.bed_list ||
    payload?.beds ||
    payload?.results ||
    payload?.data ||
    (Array.isArray(payload) ? payload : []);

  if (!Array.isArray(list)) return [];

  return list
    .map((item, index) => {
      const bedNo = String(
        item?.code ||
        item?.bed_code ||
        item?.bedCode ||
        item?.bed_no ||
        item?.bedNo ||
        item?.bed_number ||
        item?.bedNumber ||
        item?.bed_id ||
        item?.id ||
        item?.bed_name ||
        item?.name ||
        `BED-${index + 1}`
      ).trim();

      const roomNo = String(
        item?.room_no || item?.roomNo || item?.room_number || item?.room || ""
      ).trim();

      const status = String(item?.status || item?.bed_status || "")
        .toLowerCase()
        .trim();
      const occupied = item?.is_occupied ?? item?.occupied;
      const availableFlag = item?.is_available ?? item?.available;
      const isAvailable =
        typeof availableFlag === "boolean"
          ? availableFlag
          : typeof occupied === "boolean"
            ? !occupied
            : status
              ? ["available", "vacant", "unoccupied", "free"].includes(status)
              : true;

      return { bedNo, roomNo, isAvailable };
    })
    .filter((item) => item.bedNo);
}
